import './GoHomeButton.css';
import flashImg from '../../components/atomic/buttons/button/flash.png';
import goHomeIconImg from './go_home_icon.png';
import goHomeTextImg from './go_home_text.png';

type GoHomeButtonProps = {
  onClick?: () => void;
};

/** From Figma button_return_home (137:295). */
export function GoHomeButton({ onClick }: GoHomeButtonProps) {
  return (
    <button
      type="button"
      className="pause-go-home-button"
      aria-label="Вернуться домой"
      onClick={onClick}
    >
      <img
        className="pause-go-home-button__flash"
        src={flashImg}
        alt=""
        draggable={false}
      />
      <img
        className="pause-go-home-button__icon"
        src={goHomeIconImg}
        alt=""
        draggable={false}
      />
      <img
        className="pause-go-home-button__text"
        src={goHomeTextImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
